export const checkInvalidDateOrNot = (dateStr) => {
  const [day, month, year] = dateStr.split("/");

  // If the year is already a four-digit number, use it as is
  let formattedYear = parseInt(year, 10);

  // If the year is a two-digit number, add 2000 or 1900 based on the value
  if (formattedYear < 100) {
    formattedYear = formattedYear < 50 ? 2000 + formattedYear : 1900 + formattedYear;
  }

  const date = new Date(formattedYear, month - 1, day);

  if (
    date.getFullYear() !== formattedYear ||
    date.getMonth() + 1 !== parseInt(month, 10) ||
    date.getDate() !== parseInt(day, 10)
  ) {
    return null;
  }
  return date;
};


export function isValidDate(dateString) {
  // Check against the pattern using regular expression
  if (!/^\d{2}([./-])\d{2}\1\d{4}$/.test(dateString)) {
      return false; // Return false if pattern doesn't match
  }

  // Split the date to extract day, month, year
  const [day, month, year] = dateString.split(/\.|-|\//).map(Number);

  // Check the month and day ranges
  if (month < 1 || month > 12 || day < 1 || day > 31) {
      return false;
  }

  // Create a new date object from the year, month, and day
  const date = new Date(year, month - 1, day);

  // Check if the date object holds the same date, month, and year
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}